import React from 'react';
import { Paper, Skeleton, Box, Divider } from '@mui/material';
import { skeletonBg } from './skeletonStyles';

// Skeleton order summary for CheckoutPage's item-construction wait
// (999.2125). Mirrors the Step-0 Order Review Paper: title, line items,
// totals row, action buttons — so nothing jumps when the order arrives.
export default function OrderSummarySkeleton() {
  return (
    <Paper data-testid="order-summary-skeleton" variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
      <Skeleton variant="text" width="40%" height={36} sx={[skeletonBg, { mb: 2 }]} />
      {[0, 1].map((i) => (
        <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 2 }}>
          <Skeleton variant="text" width="55%" sx={skeletonBg} />
          <Skeleton variant="text" width="15%" sx={skeletonBg} />
        </Box>
      ))}
      <Divider sx={{ my: 2 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mb: 3 }}>
        <Skeleton variant="text" width="25%" sx={skeletonBg} />
        <Skeleton variant="text" width="20%" sx={skeletonBg} />
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Skeleton variant="rectangular" height={36} sx={[skeletonBg, { flex: 1, borderRadius: '2px' }]} />
        <Skeleton variant="rectangular" height={36} sx={[skeletonBg, { flex: 1, borderRadius: '2px' }]} />
      </Box>
    </Paper>
  );
}
